import React from "react";
import { Menu } from "lucide-react";

export default function PageHeader({ onMenuClick, title }) {
  return (
    <div className="flex items-center gap-3 mb-6 xxl:mb-4">
      <button
        onClick={onMenuClick}
        className="lg:hidden p-2 hover:bg-teal-100 rounded transition-colors"
        aria-label="Open menu"
      >
        <Menu className="w-6 h-6 text-teal-700" />
      </button>
      <h1 className="text-2xl xxl:text-[26px] font-semibold text-primary select-none">
        {title}
      </h1>
    </div>
  );
}
